import mutations from './mutations';

const state = {
    name: 'Complispace Primary',
    version: '0.1.0',
    copyright: '&copy;2018 <strong>Complispace Pty. Ltd.</strong> . All rights reserved.',
    initialised: false,
    searchText: '',
    apiVersion: '',
    ceVersion: '',
};

const getters = {
    name: stateData => stateData.name,
    version: stateData => stateData.version,
    copyright: stateData => stateData.copyright,
};

export default {
    namespaced: true,
    state,
    getters,
    mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/app/store.js